// Rollout gate for the slim jobs index (users/{uid}/jobsIndex).
// Tenant uids (users/{uid}), not team-member auth uids.
//
// Released to all tenants on 2026-08-06, after confirming every tenant was
// fully indexed: 97 tenants, 15,182 jobs, zero count mismatches against their
// jobs collections. The trigger and nightly reconcile keep it that way.
//
// Kept as a switch rather than deleted because every read path calls it, so
// returning false is the one-line rollback if the index ever has to come back
// out of the read path. The uid check stays: callers pass user.uid, which is
// empty until the session loads, and an empty tenant must never read an index.
export const isJobsIndexEnabledFor = (tenantUid?: string): boolean =>
  !!tenantUid;
